import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Merchant } from '../operation/operationsInterface';

interface MerchantData {
  data: Merchant | null;
}

const initialState: MerchantData = {
  data: null,
};

export const merchantDataSlice = createSlice({
  name: 'merchantData',
  initialState,
  reducers: {
    saveMerchantData: (state, action: PayloadAction<Merchant | null>) => {
      sessionStorage.setItem('merchantType', action.payload?.sales_type || '');
      state.data = action.payload;
    },
  },
});

export const { saveMerchantData } = merchantDataSlice.actions;

export default merchantDataSlice.reducer;
